import React from 'react';
import { Link } from 'react-router-dom';

export default function Advertisement() {
  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url('/images/services/advertisement-detail.jpg')` }}
        ></div>
        <div className="relative container mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Advertisement Services</h1>
            <p className="text-xl mb-8">
              Powerful advertising campaigns that drive awareness, engagement, and conversions.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-zolo-orange hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-md transition duration-300"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold mb-6">Effective Advertising Solutions for Your Business</h2>
            
            <p className="text-lg text-gray-700 mb-6">
              At Zolo Service, we create and manage targeted advertising campaigns that help businesses in Chhindwara and across India reach their ideal customers. Our data-driven approach ensures your advertising budget is used effectively to maximize return on investment.
            </p>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Advertisement Services Include:</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Google Ads</h4>
                  <p className="text-gray-700">
                    Search, display, and video advertising campaigns on Google's network to reach customers actively searching for your products or services.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Social Media Ads</h4>
                  <p className="text-gray-700">
                    Targeted advertising on Facebook, Instagram, LinkedIn, and other platforms to reach specific audience demographics.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Display Advertising</h4>
                  <p className="text-gray-700">
                    Visual banner ads across relevant websites to build brand awareness and drive website traffic.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Remarketing Campaigns</h4>
                  <p className="text-gray-700">
                    Targeted ads that follow users who have previously visited your website to encourage conversion.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Video Advertising</h4>
                  <p className="text-gray-700">
                    Engaging video ads on YouTube and other platforms to capture attention and tell your brand story.
                  </p>
                </div>
                
                <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-zolo-blue">
                  <h4 className="font-bold text-xl mb-2">Local Advertising</h4>
                  <p className="text-gray-700">
                    Geo-targeted campaigns to reach customers in Chhindwara and specific local areas.
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">Our Advertising Process</h3>
              
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4">
                    1
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Research & Strategy</h4>
                    <p className="text-gray-700">We analyze your business, target audience, and competitors to develop an effective advertising strategy.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4">
                    2
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Campaign Setup</h4>
                    <p className="text-gray-700">We create targeted ad campaigns with compelling copy, visuals, and precise audience targeting.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4">
                    3
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Optimization</h4>
                    <p className="text-gray-700">We continuously monitor and optimize campaigns to improve performance and reduce cost per acquisition.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4">
                    4
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">A/B Testing</h4>
                    <p className="text-gray-700">We test different ad variations to identify the most effective messaging and visuals.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-zolo-blue text-white font-bold mr-4">
                    5
                  </div>
                  <div>
                    <h4 className="font-bold text-xl mb-1">Reporting & Analysis</h4>
                    <p className="text-gray-700">We provide detailed reports on campaign performance, ROI, and actionable insights.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12">
              <h3 className="text-2xl font-bold mb-4">Why Choose Our Advertising Services?</h3>
              
              <ul className="space-y-4 text-lg text-gray-700">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Data-Driven Approach:</strong> We make decisions based on analytics and performance data, not guesswork.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Budget Optimization:</strong> We ensure your advertising budget is allocated efficiently to maximize results.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Targeted Campaigns:</strong> We reach the right audience with precise demographic, interest, and behavior targeting.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Creative Excellence:</strong> Our ad designs and copy are compelling and aligned with your brand identity.</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-zolo-blue mr-2 flex-shrink-0 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span><strong>Transparent Reporting:</strong> We provide clear, detailed reports on campaign performance and ROI.</span>
                </li>
              </ul>
            </div>
          </div>
          
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden sticky top-24">
              <div className="bg-gradient-to-r from-zolo-blue to-zolo-orange p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">Ready to Advertise?</h3>
                <p className="mb-0">Contact us today for a free consultation and advertising strategy.</p>
              </div>
              
              <div className="p-6">
                <form className="space-y-4">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Name</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Email</label>
                    <input 
                      type="email" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Email"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Phone</label>
                    <input 
                      type="tel" 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      placeholder="Your Phone"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Advertising Budget</label>
                    <select 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                    >
                      <option value="">Select Budget Range</option>
                      <option value="5000-10000">₹5,000 - ₹10,000</option>
                      <option value="10000-25000">₹10,000 - ₹25,000</option>
                      <option value="25000-50000">₹25,000 - ₹50,000</option>
                      <option value="50000+">₹50,000+</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">Message</label>
                    <textarea 
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-zolo-blue"
                      rows={4}
                      placeholder="Tell us about your advertising goals"
                    ></textarea>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="w-full bg-zolo-blue hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-md transition duration-300"
                  >
                    Get a Free Consultation
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
